<template>
  <div class="holidayguru">
    <div
      :class="`hg-navbar-container ${
        navBorder ? 'hg-navbar-container__border' : ''
      }`"
    >
      <HgNavbar
        class="hg-navbar"
        :lang="lang"
        :isMounted="mounted"
        :pathName="pathName"
        @onClickBookmark="gotoBookmark"
        @onClickUser="gotoProfile"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    locale: {
      type: String,
      default: null
    },
    navBorder: {
      type: Boolean,
      default: true
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      mounted: false,
      pathName: window.location.href
    }
  },
  methods: {
    gotoBookmark() {
      window.location.href =
        this.$i18n.messages[this.lang].headerFooterData.wishlistUrl
    },
    gotoProfile() {
      window.location.href =
        this.$i18n.messages[this.lang].headerFooterData.profileUrl
    }
  },
  created() {
    if (this.locale) {
      this.lang = this.locale
    } else if (window.location.host.includes(".at")) {
      this.lang = "at"
    } else if (window.location.host.includes(".ch")) {
      this.lang = "ch"
    } else if (window.location.host.includes(".es")) {
      this.lang = "es"
    } else if (window.location.host.includes(".nl")) {
      this.lang = "nl"
    } else {
      this.lang = "de"
    }
  },
  mounted() {
    if (this.delay > 0) {
      setTimeout(() => {
        this.mounted = true
      }, this.delay)
    } else {
      this.mounted = true
    }
  }
}
</script>

<style>
.hg-navbar-header {
  width: 180px;
}
@media screen and (min-width: 768px) {
  .hg-navbar-header {
    width: 240px;
  }
}

.hg-header.hg-navbar {
  z-index: 50 !important;
  padding-top: 0 !important;
}

.hg-navbar-container {
  width: 100%;
  background-color: white;
  min-height: 68px;
  padding: 8px;
}

@media (min-width: 1024px) {
  .hg-navbar-container {
    min-height: 89px;
  }
}

.hg-navbar {
  margin: 0 auto;
  width: 100%;
  max-width: 1400px;
}

.hg-navbar-container__border {
  border-bottom: 4px solid #dcfaf5;
}

.hg-deals-heading-nav a {
  width: 100%;
}
</style>
